import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    public financiadorID;
    public userId;
    public userData;
    public bUserData: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    constructor() {}

    public setUserData(t) {
        this.userData = t;
        this.bUserData.next(t);
    }

    public getUserData() {
        return this.userData;
    }

    public bindUserData() {
        return this.bUserData.asObservable();
    }

    public setUserId(t) {
        this.userId = t;
    }

    public getUserId() {
        return this.userId;
    }
    
    public setFunderId(id) {
        this.financiadorID = id;
    }

    public getFunderId() {
        return this.financiadorID;
    }

    public getUserRole() {
        return this.userData.role;
    }

}
